import { CustomCheckboxSettings } from '@pages/Admin/PlatformSettings2/components/CheckboxSettings';
import s from './index.module.css';
import { useState } from 'react';
import Button from '../../../UI/Button';
import { useDispatch } from "react-redux";
import TYPES from "../../TYPES";
import { closeModal } from "@store/modalsSlise";

const SelectionCourseBlocks = ({
    data
}) => {
    const [ids, setIds] = useState([]);
    const dispatch = useDispatch();
    const close = () => dispatch(
        closeModal({
            type: TYPES.SELECTION_COURSE_BLOCKS
        })
    )
    return (<>
        <div className={s.title}>
            Выберите блоки курса, по которым загрузить КТП в таблицу
        </div>
        <div className={s.body}>
            {
                data.blocks.map(block =>
                    <CustomCheckboxSettings
                        key={block.id}
                        value={ids.includes(block.id)}
                        label={block.name}
                        onClick={() => setIds(ids =>
                            ids.includes(block.id) ?
                            ids.filter(id => id !== block.id) :
                            ids.concat(block.id)
                        )}
                    />
                )
            }
            <Button
                newDesign
                className={s.add}
                action={() => {
                    data.handle(null, ids);
                    close();
                }}
                disabled={!ids.length}
            >Загрузить КТП</Button>
        </div>
    </>)
}

export default SelectionCourseBlocks;